export const url = {
    baseURL : "https://api.datheron.com/api/v1",//"https://localhost:44369/api/v1",
    CREATE_ACTION_NAME : "save",
    UPDATE_ACTION_NAME : "update",
    DELETE_ACTION_NAME : "remove",
    GET_ACTION_NAME : "get",
    FETCH_ACTION_NAME : "getAll",
};